module.exports = __webpack_public_path__ + "static/media/restaurant_empty_screen.86ccd182.png";